import styled from "styled-components";

export const List = styled.div`
  height: 94vh;
  background: #f8f8fb;
  overflow-y: scroll;
`;

export const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  width: 36px;
  border: 1px solid #f8f8fb;
  border-radius: 50%;
`;

export const FilterBox = styled.div`
  display: flex;
  min-width: max-content;
  background-color: ${(props) => (props.clicked ? "#FFF5F6;" : "white")};
  border: ${(props) => (props.clicked ? "1px solid #EF4F5F" : "none")};
  box-shadow: 0px 4px 20px rgba(28, 28, 28, 0.04);
  border-radius: 8px;
  margin-right: 1rem;
  padding: 10px;
  justify-content: center;
  cursor: pointer;
  color: ${(props) => (props.clicked ? "#212121" : "#596378")};
  font-weight: ${(props) => (props.clicked ? "500" : "400")};
`;

export const SearchBarContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchIcon = styled.img`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
  filter: brightness(0) saturate(100%) invert(30%) sepia(97%) saturate(2349%)
    hue-rotate(341deg) brightness(97%) contrast(89%);
`;

export const SearchBar = styled.input`
  width: 100%;
  padding: 12px 16px 12px 48px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: #ef4f5f;
  }

  &::placeholder {
    color: #9e9e9e;
  }
`;

export const POCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 16px;
  margin: 12px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const PONumber = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #020101ff;
  margin-bottom: 12px;
`;

export const Divider = styled.div`
  height: 1px;
  border: 1px solid #f2f4f7;
  margin: 12px -16px;
`;

export const POAmountText = styled.div`
  font-size: 14px;
  color: #616161;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TotalInvoiceText = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #3ab757;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DownloadLink = styled.a`
  font-size: 14px;
  color: #e23744;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;

  &:hover {
    text-decoration: underline;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 12px;
`;

export const ActionButton = styled.button`
  flex: 1;
  padding: 12px 10px;
  border: 1px solid #ef4f5f;
  background: ${(props) => (props.primary ? "#EF4F5F" : "white")};
  color: ${(props) => (props.primary ? "white" : "#EF4F5F")};
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const TabContainer = styled.div`
  display: flex;
  padding: 0 16px;
  gap: 12px;
  margin: 16px 0;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StatusFilterButton = styled.button`
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  background: white;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 400;
  color: #afb4c0;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
  max-width: fit-content;

  &:hover {
    background: #f5f5f5;
  }
`;

export const EntityCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 16px;
  margin: 12px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const EntityNumber = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #212121;
  margin-bottom: 4px;
`;

export const EntitySubtextContainer = styled.div`
  margin-bottom: 12px;
`;

export const EntitySubtext = styled.div`
  font-family: "Lexend", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0%;
  color: #9197a6;
`;

export const GreyContainer = styled.div`
  background: #f2f4f7;
  border-radius: 12px;
  padding: 4px 4px 4px 4px;
  margin: 16px 0 0 0;
`;

export const HorizontalBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 6px;
  border-radius: 10px;
`;

export const LeftBlock = styled.div`
  flex: 1;
`;

export const RightBlock = styled.div`
  display: flex;
  align-items: center;
`;

export const AmountLabel = styled.div`
  font-family: "Lexend", sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: left;
  color: #9197a6;
  margin-bottom: 8px;
  margin-top: 4px;
`;

export const AmountValue = styled.div`
  font-family: "Lexend", sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: left;
  color: #293142;
  margin-top: 6px;
`;

export const StatusBadge = styled.div`
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${(props) => {
    switch (props.status?.toLowerCase()) {
      case "verified":
      case "approved":
        return "#e8f5e9";
      case "pending":
        return "#fff3e0";
      case "rejected":
        return "#ffebee";
      default:
        return "#f5f5f5";
    }
  }};
  color: ${(props) => {
    switch (props.status?.toLowerCase()) {
      case "verified":
      case "approved":
        return "#2e7d32";
      case "pending":
        return "#f57c00";
      case "rejected":
        return "#c62828";
      default:
        return "#616161";
    }
  }};
`;

export const PaymentText = styled.div`
  font-size: 12px;
  color: #9197a6;
  margin: 8px 0;
`;

export const PaymentInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 8px 0;
  position: relative;
`;

export const InfoIcon = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #9197a6;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  position: relative;

  &:hover + div {
    opacity: 1;
    visibility: visible;
  }
`;

export const ModalOption = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  font-size: 14px;
  color: #212121;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background: #f5f5f5;
  }
    

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-bottom: none;
    border-radius: 0 0 8px 8px;
  }
`;

export const RadioButton = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${(props) => (props.selected ? "#e23744" : "#e0e0e0")};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &::after {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #e23744;
    display: ${(props) => (props.selected ? "block" : "none")};
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const ModalContent = styled.div`
  background: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
`;

export const ModalTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #212121;
`;

export const ModalSubtitle = styled.div`
  font-size: 12px;
  margin-top: 4px;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #9e9e9e;
  cursor: pointer;
  padding: 0;
  line-height: 1;
`;

export const ModalContentTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #212121;
  margin-bottom: 8px;
`;

export const ModalContentText = styled.div`
  font-size: 14px;
  color: #616161;
  line-height: 1.5;
`;

export const WhiteButton = styled.button`
  color: white;
`;

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 400px;
  text-align: center;
  color: #9e9e9e;
  font-size: 14px;
`;

export const ButtonText = styled.span`
  margin-left: 8px;
  font-size: 14px;
`;

export const ActionButtonText = styled.span`
  margin-left: 8px;
  font-size: 12px;
`;

export const RejectionReasonText = styled.div`
  margin-top: 8px;
  font-size: 12px;
  color: #f57c00;
`;

export const FilterStatusText = styled.div`
  font-size: 13px;
`;

export const PaymentInfoContainerSpaced = styled(PaymentInfoContainer)`
  margin-top: 8px;
`;

export const PaymentTextNoMargin = styled(PaymentText)`
  margin: 0;
`;

export const StatusBadgeClickable = styled(StatusBadge)`
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
`;

export const ModalOptionTop = styled(ModalOption)`
  border-radius: 8px 8px 0 0;
`;

export const ModalOptionBottom = styled(ModalOption)`
  border-radius: 0 0 8px 8px;
`;

export const CloseButtonModal = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #9e9e9e;
  cursor: pointer;
  padding: 0;
  line-height: 1;
`;

export const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const ModalHeaderTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #212121;
`;

export const ModalHeaderSubtitle = styled.div`
  font-size: 12px;
  margin-top: 4px;
`;

export const ModalContentBox = styled.div`
  background: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
`;
